module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av627-1771ba200fc404cf635cfc3a20caf9b4.jpg";